<template>

  <main>
    <app-draw-feature 
      @drawend="onDrawEnd"
      ref="draw" :map="map" :mode="drawMode" :active="isActive" :drawing="isDrawActive"></app-draw-feature>

    <app-raster-legend
      ref="legend"
      :value="isActive && !isDynamicStyle"
      style="position: absolute; bottom: 15px; margin-left: 15px; z-index: 1;"
      layout="vertical" class="app-raster-legend"></app-raster-legend>

    <v-navigation-drawer ref="nav" app disable-resize-watcher hide-overlay mobile-break-point="0" :value="isActive" width="500">
      <v-container fluid class="pa-0">
        <v-toolbar flat>
          <v-toolbar-title>Ratios</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$store.dispatch('disableControl')" :disabled="isLoading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-container>

      <v-divider></v-divider>

      <v-container fluid class="pa-0">
        <v-card flat :color="`grey ${$store.getters.isDarkTheme ? 'darken-4' : 'lighten-4'}`" height="64">
          <div class="container-buttons">
            <v-tooltip bottom style="align-self: center;">
              <v-btn slot="activator" @click="repeatSearch" :disabled="disabledButtons" fab small color="green darken-2">
                <v-icon>youtube_searched_for</v-icon>
              </v-btn>
              <span>{{ $t('_busquedas.nueva') }}</span>
            </v-tooltip>

            <v-tooltip bottom style="align-self: center;">
              <v-btn slot="activator" @click="showBufferDialog = true" :disabled="disabledButtons" fab small color="green darken-2">
                <v-icon>open_with</v-icon>
              </v-btn>
              <span>{{ $t('_busquedas.buffer') }}</span>
            </v-tooltip>
          </div>
        </v-card>
      </v-container>

      <app-select-draw-mode
        ref="drawModeSelector" 
        @change-draw-mode="onDrawModeChange"
        poligono rectangulo defaultMode="Polygon"></app-select-draw-mode>

      <v-scale-transition>
        <v-alert v-show="isDrawActive" type="info" :color="$store.getters.isDarkTheme ? 'green darken-2' : 'green lighten-2'" class="mt-0">
          {{ $t(drawMode == geometryModes.POINT ? 'dibuja.punto' : 'dibuja.poligono') }}
        </v-alert>
      </v-scale-transition>


      <v-container fluid class="pa-0">
        <v-toolbar 
          style="cursor: pointer;"
          @click="collapsed = !collapsed" :color="`green ${$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'}`">
          <v-btn icon>
            <v-icon>settings</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 16px;">{{$t('opciones')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="collapsed = !collapsed">
            <v-icon>{{collapsed ? 'add' : 'remove'}}</v-icon>
          </v-btn>
        </v-toolbar>
      </v-container>

      <v-divider :dark="$store.getters.isDrakTheme" v-if="collapsed && isDynamicStyle"></v-divider>

      <v-container fluid class="pa-0">
        <v-slide-y-transition>
          <v-card v-show="!collapsed" :color="$store.getters.isDarkTheme ? 'grey darken-4' : 'grey lighten-4'" class="px-3 pb-3">
            <v-layout row wrap>
              <v-flex xs6 class="px-2">
                <app-select-indicador
                  :disabled="true"></app-select-indicador>
              </v-flex>
              <v-flex xs6 class="px-2">
                <app-select-period
                  :disabled="disabledButtonsByDialogs || (isDrawActive && !!result)"></app-select-period>
              </v-flex>

              <v-flex xs6 class="px-2">
                <app-select-ortofotos
                  :map="map"
                  :ortoLayer="LayerOrto"
                  :disabled="disabledButtonsByDialogs || (isDrawActive && !!result)"></app-select-ortofotos>
              </v-flex>

              <v-flex xs6 class="px-2">
                <app-select-raster
                  ref="rasterselect"
                  :value="isActive"
                  :disabled="disabledButtonsByDialogs || (isDrawActive && !!result)"></app-select-raster>
              </v-flex>

              <v-flex xs12 class="px-2">
                <app-select-saved-polygon
                  ref="selectSavedPolygon"
                  v-show="drawMode == geometryModes.POLYGON || drawMode == geometryModes.CIRCLE"
                  :map="map"
                  :disabled="isLoading || showBufferDialog"
                  @selected="onSelectedSavedPolygon"
                ></app-select-saved-polygon>
              </v-flex>
            </v-layout>

          </v-card>
        </v-slide-y-transition>
      </v-container>

      <!-- Diálogo para elegir la distancia del buffer -->
      <app-buffer-feature
        @selected="onBufferSelected"
        @cancel="showBufferDialog = false"
        :feature="lastFeature"
        :map="map"
        :value="showBufferDialog"></app-buffer-feature>


      <v-divider :dark="$store.getters.isDrakTheme"></v-divider>

      <v-scale-transition>
        <v-container v-show="!!result" fluid class="pa-0">
          <v-layout row wrap style="justify-content: space-around;">
            <v-flex xs6>
              <v-card height="140" flat ripple>
                <v-card-text class="text-xs-center">
                  <v-card-actions>
                    <v-btn color="primary" icon style="margin: 0px auto;">
                      <vector-polygon-icon style="font-size: 24px;"></vector-polygon-icon>
                    </v-btn>
                  </v-card-actions>
                  <h2 v-html="formattedArea"></h2>
                  <span>{{$t('area-poligono')}}</span>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs6>
              <v-card height="140" flat ripple>
                <v-card-text class="text-xs-center">
                  <v-card-actions>
                    <v-btn color="primary" icon :ripple="false" style="margin: 0px auto;">
                      <v-icon>people</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <h2>{{population || 0}} hab.</h2>
                  <span>{{$t('poblacion-afectada')}}</span>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs6>
              <v-card height="140" flat ripple>
                <v-card-text class="text-xs-center">
                  <v-card-actions>
                    <v-btn color="primary" icon :ripple="false" style="margin: 0px auto;">
                      <v-icon>nature</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <h2>{{Math.round(greenSurface)}} m<sup>2</sup></h2>
                  <span>Superficie Zona Verde</span>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs6>
              <v-card height="140" flat ripple>
                <v-card-text class="text-xs-center">
                  <v-card-actions>
                    <v-btn color="primary" icon style="margin: 0px auto;">
                      <v-icon>nature_people</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <h2>{{Math.round(greenSurface / population)}} m<sup>2</sup>/hab.</h2>
                  <span>Superficie Zona Verde por hab.</span>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12>
              <v-card height="140" flat ripple>
                <v-card-text class="text-xs-center">
                  <v-card-actions>
                    <v-btn color="primary" icon style="margin: 0px auto;">
                      <v-icon>nature</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <h2>{{(greenSurface * 100 / affectedArea).toFixed(2)}} %</h2>
                  <span>% Superficie Zona Verde</span>
                </v-card-text>
              </v-card>
            </v-flex>

          </v-layout>
        </v-container>
      </v-scale-transition>

    </v-navigation-drawer>

  </main>
</template>


<script>
import * as API from '@/api'
import * as GSRest from '@/api/gsrest'
import config from '@/config'
import getSortFunction from '../utils/sort'

import SourceTileWMS from 'ol/source/tilewms'
import VectorLayer from 'ol/layer/vector'
import VectorSource from 'ol/source/vector'
import OLSphere from 'ol/sphere'

import GeomPolygon from 'ol/geom/polygon'
import GeomPoint from 'ol/geom/point'
import Feature from 'ol/feature'
import GeoJSONFormat from 'ol/format/geojson'
import Fill from 'ol/style/fill'
import Style from 'ol/style/style'
import SourceRaster from 'ol/source/raster'
import ImageLayer from 'ol/layer/image'

import AppRasterFilter from '../utils/shared-components/raster-range-filter'
import AppSelectIndicador from '../utils/shared-components/select-indicador'
import AppSelectPeriod from '../utils/shared-components/select-period'
import AppSelectRaster from '../utils/shared-components/select-raster'
import AppSelectOrtofotos from '../utils/shared-components/select-ortofoto'
import AppSelectSavedPolygon from '../utils/shared-components/select-saved-polygon'
import AppBufferFeature from '../utils/shared-components/buffer-feature'
import AppDrawFeature from '../utils/shared-components/draw-feature'
import AppRasterLegend from '../utils/shared-components/raster-legend'
import AppSelectDrawMode from '../utils/shared-components/select-draw-mode'

import { LayerOrto, LayerAmbito, LayerRaster } from '../utils/layers'
import { showStyle, styleDifference } from '../utils/style'
import GetFeatureDifference from '../utils/feature-difference'

const geoserverURL = `${config.geoserver.geoserverURL}/wms`

const GeoJSONParser = new GeoJSONFormat
const LayerShow = new VectorLayer({ source: new VectorSource, style: showStyle })
const LayerResult = new VectorLayer({ source: new VectorSource, style: new Style({fill: new Fill({color: 'rgba(0,0,0, 0.5)'})}) })

/**
 * Componente para calcular ratios a partir de rásters de vegetación
 */
export default {

  props: ['map'],

  components: {
    AppRasterFilter,
    AppSelectIndicador,
    AppSelectPeriod,
    AppSelectRaster,
    AppSelectOrtofotos,
    AppSelectSavedPolygon,
    AppBufferFeature,
    AppRasterLegend,
    AppDrawFeature,
    AppSelectDrawMode
  },

  data() {
    return {
      /* Identificador del Componente */
      id: 'Ratios-Vegetacion',

      /* Podemos dibujar un punto o polígono */
      geometryModes: {
        POLYGON: 'Polygon',
        CIRCLE: 'Circle'
      },

      drawMode: null,

      clickHandlerId: null,

      lastFeature: null,

      result: null,

      showBufferDialog: false,

      isDynamicStyle: false,

      LayerRaster,
      LayerOrto,

      isDrawActive: false,

      affectedPopulation: null,
      greenSurface: 0,

      collapsed: false
    }
  },

  methods: {

    onDrawModeChange(mode) {
      this.drawMode = mode
      if(this.isActive) {
        this.isDrawActive = true
      }
    },

    checkControl(newControl, lastControl) {
      return newControl.startsWith(this.id) || lastControl.startsWith(this.id)
    },
    
    async getResultsForPolygon(feature) {
      this.result = null
      const layerName = this.raster.name.replace('vegetacion', 'beneficios')
      const beneficiosLayer = this.beneficiosLayers.find(({name}) => name == layerName)

      //console.logconsole.log(beneficiosLayer)

      const promises = [
        API.getGeoJSONZonaVerde(feature, beneficiosLayer),
        API.getPopulation(feature)
      ]

      const [zonaVerde, population] = await Promise.all(promises)

      this.affectedPopulation = population
      this.result = zonaVerde
    },

    async calculate() {
      if(this.lastFeature) {
        this.isLoading = true
        const type = this.lastFeature.getGeometry().getType()
        if(type == 'Polygon' || type == 'Circle') {
          await this.getResultsForPolygon(this.lastFeature)
        } else if(type == 'Point') {
          await this.getResultsForPoint(this.lastFeature)
        }
        this.isLoading = false
      }
    },

    repeatSearch() {     
      this.isDrawActive = true
      this.selectedPolygon = null
      this.result = null
    },

    onBufferSelected(bufferFeature) {
      this.showBufferDialog = false
      this.selectedPolygon = null

      this.$nextTick(() => this.lastFeature = bufferFeature)
    },

    fitMapToFeatureExtent(duration = 500) {
      if(this.lastFeature) {
        const type = this.lastFeature.getGeometry().getType()
        const extent = this.lastFeature.getGeometry().getExtent()
        const constrainResolution = false
        const padding = [10, 10, 10, 10]
        const center = this.lastFeature.getGeometry().getCoordinates()
        const zoom = 15

        if(type == 'Point') {
          this.map.getView().animate({ center, duration: duration / 2 }, { zoom, duration: duration / 2 })
        } else {
          this.map.getView().fit(extent, { duration, constrainResolution, padding })
        }

      }
    },

    paintRaster() {
      if(!this.raster) {
        return
      }

      const { name: layers, url } = this.raster
      const source = new SourceTileWMS({ url, params: { layers }, crossOrigin: 'anonymous' })
      
      LayerRaster.setSource(source)
    },

    onSelectedSavedPolygon(selectedPolygon) {
      this.isDrawActive = false
      this.lastFeature = selectedPolygon
    },

    onDrawEnd(feature) {
      this.isDrawActive = false
      this.lastFeature = feature
    }
  },

  computed: {

    population() {
      if(!this.affectedPopulation) {
        return
      }

      if(typeof this.affectedPopulation == 'object') {
        const { POBLACION } = this.affectedPopulation
        return POBLACION
      }

      return this.affectedPopulation
    },

    formattedArea() {
      const area = this.affectedArea
      let output = ''

      if(!area) {
        return
      }

      if (area > 10000) {
        output = `${(Math.round(area / 1000000 * 100) / 100)} km<sup>2</sup>`
      } else {
        output = `${(Math.round(area * 100) / 100)} m<sup>2</sup>`
      }
      
      return output
    },

    affectedArea() {
      if(!this.lastFeature) {
        return
      }
      
      const geometry = this.lastFeature.getGeometry()
      const type = geometry.getType()

      return type != 'Point' && OLSphere.getArea(geometry)
    },

    selectedPolygon: {
      get() { return this.$refs.selectSavedPolygon && this.$refs.selectSavedPolygon.$data.selectedPolygon },
      set(value) { this.$refs.selectSavedPolygon.$data.selectedPolygon = value }
    },

    raster: {
      get() { return this.$store.getters.raster },
      set(value) { this.$store.dispatch('setRaster', value) }
    },


    beneficiosLayers() {
      const allLayers = this.$store.getters.layers
      const keyLayers = GSRest.getOrderedLayersOf(allLayers, 'beneficios')

      const periodLower = this.period.toLowerCase()

      return keyLayers
        .filter(({name}) => name.indexOf(periodLower) > -1)
        .map(layerInfo => Object.assign({}, layerInfo, {
          name: `${config.geoserver.geoserverWorkspace}:${layerInfo.name}`,
          url: geoserverURL,
        }))
        .sort(getSortFunction(this.period))
    },

    period() {
      return this.$store.getters.period
    },

    disabledButtons() {
      return !!!this.result || this.isLoading || this.showBufferDialog || this.isDrawActive
    },

    disabledButtonsByDialogs() {
      return this.isLoading || this.showBufferDialog
    },

    indicadores() {
      return Object.keys(this.$store.getters.indicadores)
        .map(str => str.charAt(0).toUpperCase() + str.slice(1))
    },

    isLoading: {
      get() {
        return this.$store.getters.isLoading
      },
      set(value) {
        this.$store.dispatch('setLoading', value)
      }
    },

    activeControlId() {
      return this.$store.getters.activeControlId
    },
    
    isActive() {
      return (!!this.activeControlId) && this.activeControlId.startsWith(this.id)
    },

    indicador() {
      return this.$store.getters.indicador
    },

  },

  watch: {

    result(geojson) {
      if(!geojson) {
        return LayerResult.getSource().clear()
      }

      const features = GeoJSONParser.readFeatures(geojson)
      LayerResult.getSource().clear()
      LayerResult.getSource().addFeatures(features)

      // Ratios
      // Superficie zona verde
      this.greenSurface = features.reduce((sum, feature) => {
        return sum + OLSphere.getArea(feature.getGeometry())
      }, 0)
    },

    map() {
      const fn = () => {
        if(!this.lastFeature || this.isDrawActive || this.mode == 'Point') return

        LayerShow.getSource().clear()

        const extent = this.map.getView().calculateExtent()
        const p1 = new Feature({ geometry: GeomPolygon.fromExtent(extent) })
        const p2 = this.lastFeature

        const feature = GetFeatureDifference(p1, p2, this.map.getView().getProjection())

        if(!feature) {
          return LayerShow.getSource().addFeature(this.lastFeature)
        }

        feature.setStyle(styleDifference)

        LayerShow.getSource().addFeature(feature)
        LayerShow.getSource().addFeature(this.lastFeature)
      }

      this.map.getTargetElement().addEventListener('resize', fn)
      this.map.on('precompose', fn)
      this.map.on('postcompose', fn)
    },

    lastFeature() {
      if(!this.lastFeature) {
        return
      }

      this.lastFeature.setStyle(showStyle)
      
      LayerShow.getSource().clear()
      LayerShow.getSource().addFeature(this.lastFeature)

      this.fitMapToFeatureExtent()
      this.calculate()
    },

    activeControlId(newControl, lastControl) {
      if(!this.checkControl(newControl || '', lastControl || '')) {
        return
      }

      this.map.getLayers().forEach(layer => layer.setVisible(!this.isActive))

      ;[LayerOrto, LayerRaster, LayerAmbito, LayerShow, LayerResult]
        .forEach(layer => layer.setMap(this.isActive ? this.map : null))


      this.isActive && this.paintRaster()
      this.isActive && this.$parent.fitIntoProjectExtent()

      LayerShow.getSource().clear()
      
      this.collapsed = false
      this.affectedPopulation = null
      this.isDrawActive = !!this.isActive
      // this.isDynamicStyle = false
      this.result = null
      this.showBufferDialog = false
      this.selectedPolygon = null
      this.lastFeature = null
    },

    raster() {
      if(this.isActive) {
        this.paintRaster()
        this.calculate()
      }
    },

    isDynamicStyle() {
      if(!this.isDynamicStyle) {
        this.paintRaster()
      }
    },

    showBufferDialog(show) {
      if(show) {
        LayerShow.getSource().clear()
      }
    },

    isDrawActive(active) {
      if(active) {
        LayerResult.getSource().clear()
        LayerShow.getSource().clear()
      }
    }
  },
}
</script>


<style>
.container-buttons {
  display: flex;
  justify-content: space-around;
  height: 100%;
}

.highcharts-container {
  width:100% !important;
}
</style>



// WEBPACK FOOTER //
// Ratios.vue?fae406d4